<template>
  <div class="container">
    <Header :theme="theme"></Header>
    <div class="fullPage" ref="fullPage">
      <div
        class="fullPageContainer"
        ref="fullPageContainer"
        @mousewheel="mouseWheelHandle" 
        @DOMMouseScroll="mouseWheelHandle"
      >
        <div :class="`banner ${fullpage.current===1?'in':'out'}`" :style="`background-image: url(${bannerBack})`">
          <div class="content">
            <div class="text">
              <p class="name">联系我们</p>
              <p class="en">Contact Us</p>
            </div>
          </div>
        </div>
        <div :class="`detail ${fullpage.current===2?'in':'out'}`">
          <div class="content">
            <div class="left">
              <p class="en">Contact Us</p>
              <div class="divider"></div>
              <p class="cn">联系我们</p>
              <el-image class="logo" :src="leftImg"></el-image>
            </div>
            <div class="right">
              <div class="map">
                <el-image class="cover" :src="mapCover"></el-image>
                <div class="item">
                  <el-image class="icon" :src="addressIcon"></el-image>
                  <div class="info">
                    <p class="label">地址</p>
                    <p class="value">{{contactInfo.address}}</p>
                  </div>
                </div>
                <div class="item">
                  <el-image class="icon" :src="messageIcon"></el-image>
                  <div class="info">
                    <p class="label">电子邮箱</p>
                    <p class="value">{{contactInfo.email}}</p>
                  </div>
                </div>
                <div class="item">
                  <el-image class="icon" :src="phoneIcon"></el-image>
                  <div class="info">
                    <p class="label">电话</p>
                    <p class="value">{{contactInfo.phone}}</p>
                  </div>
                </div>
              </div>
              <div class="consult">
                <el-image class="cover" :src="consultCover"></el-image>
                <p class="title">免费咨询专业解答</p>
                <p class="des">服务时间为：工作日9:00至18:00</p>
                <el-form class="login-form" ref="form" :model="form" :rules="rules" hide-required-asterisk>
                  <el-form-item prop="name">
                    <el-input
                      class="input"
                      v-model.trim="form.name" 
                      placeholder="如何称呼您" 
                      maxlength="20">
                    </el-input>
                  </el-form-item>
                  <el-form-item prop="phone">
                    <el-input
                      class="input"
                      v-model.trim="form.phone" 
                      placeholder="请输入您的电话号码"
                      maxlength="11">
                    </el-input>
                  </el-form-item>
                  <el-button class="btn" :loading="loading" type="primary" @click.native.prevent="submit" v-show="!submitStatus">立刻联系</el-button>
                  <el-button class="btn" type="primary" :disabled="true" v-show="submitStatus">已提交，请耐心等待我们的回复</el-button>
                </el-form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Header from "@/layout/Header"
import { 
  api_submitConsult,
} from "@/api/common"
export default {
  components:{
    Header,
  },
  data(){
    return{
      bannerBack:require("@/assets/img/contact/banner.png"),
      leftImg:require("@/assets/img/contact/left.png"),
      consultCover:require("@/assets/img/contact/consult.png"),
      mapCover:require("@/assets/img/contact/map.png"),
      addressIcon:require("@/assets/img/contact/address.png"),
      messageIcon:require("@/assets/img/contact/message.png"),
      phoneIcon:require("@/assets/img/contact/phone.png"),
      theme:"white",
      fullpage: {
        current: 1, // 当前的页面编号
        isScrolling: false, // 是否在滚动,是为了防止滚动多页，需要通过一个变量来控制是否滚动
        deltaY: 0 // 返回鼠标滚轮的垂直滚动量，保存的鼠标滚动事件的deleteY,用来判断是往下还是往上滚
      },
      form:{},
      rules: {
        name: [{ required: true, trigger: 'change', message: '称呼不能为空' }],
        phone: [{ required: true, trigger: 'change', message:  '电话号码不能为空'}]
      },
      loading: false,
      submitStatus:false,
      contactInfo:{
        address:"江苏省南京市江宁区麒麟科创园",
        email:"651849650@qq.com",
        phone:"025-86111066"
      }
    }
  },
  created(){
  },
  methods:{

    submit(){
      this.$refs.form.validate(valid => {
        if (valid) {
          this.loading = true
          let params={
            name:this.form.name,
            phone:this.form.phone
          }
          api_submitConsult(params)
            .then((res) => {
              if(res && res.code===0){
                this.$message.success("已将联系方式发送到公司邮箱，敬请等待回电")
                this.submitStatus=true
              }
            })
            .finally(()=>{
              this.loading=false
            })
            setTimeout(()=>{
              this.loading=false
            },5000)
        } else {
          return false
        }
      })
    },

    next() { // 往下切换
      let len = 2; // 页面的个数
      if (this.fullpage.current + 1 <= len) { // 如果当前页面编号+1 小于总个数，则可以执行向下滑动
      this.fullpage.current += 1; // 页面+1
      this.move(this.fullpage.current); // 执行切换
      }
    },
    pre() {// 往上切换
      if (this.fullpage.current - 1 > 0) { // 如果当前页面编号-1 大于0，则可以执行向下滑动
      this.fullpage.current -= 1;// 页面+1
      this.move(this.fullpage.current);// 执行切换
      }
    },
    move(index) {
      this.fullpage.isScrolling = true; // 为了防止滚动多页，需要通过一个变量来控制是否滚动
      this.directToMove(index); //执行滚动
      if(index===2){
        this.theme="black"
      }else{
        this.theme="white"
      }
      setTimeout(() => {  //这里的动画是1s执行完，使用setTimeout延迟1s后解锁
      this.fullpage.isScrolling = false;
      }, 1010);
    },
    directToMove(index) {
      let height = this.$refs["fullPage"].clientHeight; //获取屏幕的宽度
      let scrollPage = this.$refs["fullPageContainer"]; // 获取执行tarnsform的元素
      let scrollHeight; // 计算滚动的告诉，是往上滚还往下滚
      scrollHeight= -(index - 1) * height + "px";
      scrollPage.style.transform = `translateY(${scrollHeight})`;
      this.fullpage.current = index;
    },
    mouseWheelHandle(event) { // 监听鼠标监听
      // 添加冒泡阻止
      let evt = event || window.event;
      if (evt.stopPropagation) {
      evt.stopPropagation();
      } else {
      evt.returnValue = false;
      }
      if (this.fullpage.isScrolling) { // 判断是否可以滚动
      return false;
      }
      let e = event.originalEvent || event;
      this.fullpage.deltaY = e.deltaY || e.detail; // Firefox使用detail
      if (this.fullpage.deltaY > 0) {
      this.next();
      } else if (this.fullpage.deltaY < 0) {
      this.pre();
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.container{
  width: 100%;
  animation-timing-function: ease;

  .fullPage{
    height: 100vh;
    overflow: hidden;

    .fullPageContainer{
      width: 100%;
      height: 100vh;
      transition: all linear 1s;

      .banner{
        width: 100%;
        height: 100vh;
        background-repeat: no-repeat;
        background-size: cover;
        overflow: hidden;
        display: flex;
        align-items: center;

        .content{
          width: 100rem;
          margin: 0 auto;
          color: #fff;
          height: 57.5rem;
          display: flex;
          align-items: center;
          justify-content: center;
          text-align: center;

          .text{

            .name{
              font-size: 8.125rem;
              line-height: 9.75rem;
              letter-spacing: .625rem;
              font-weight:bold;
            }
            .en{
              font-size: 2.8125rem;
              line-height: 3.6875rem;
              font-weight: 400;
              margin-top: 1rem;
            }
          }
        }
      }
      .detail{
        width: 100%;
        height: 100vh;
        background-color: #fff;
        display: flex;
        justify-content: space-between;
        align-items: center;

        .content{
          width: 100rem;
          margin: 0 auto;
          color: #373737;
          height: 57.5rem;
          display: flex;
          justify-content: space-between;

          .left{
            margin-top: 9.375rem;
            width: 13.125rem;
            position: relative;

            .en{
              font-size: 1.875rem;
              line-height: 3.75rem;
              font-weight: bold;
              opacity: 0.5;
            }
            .divider{
              width: 3.75rem;
              height: .25rem;
              background-color: #373737;
            }
            .cn{
              margin-top: 1.25rem;
              font-size: 2rem;
              line-height: 2.375rem;
              font-weight: bold;
            }
            .logo{
              position: absolute;
              width:18.75rem;
              height: 21.875rem;
              top: 18.875rem;  
              left: -10rem; 
            }
          }
          .right{
            margin-top: 9.375rem;
            width: 70.9375rem;
            height: 37.6875rem;
            display: flex;
            justify-content: space-between;

            .map{
              width: 32.6875rem;
              margin-right: 5.5625rem;
              border-radius: 0 0 3.125rem 0;
              border: .0625rem solid rgba(0,0,0,0.1);

              .cover{
                width: 100%;
                height: 13.875rem;
              }
              .item{
                margin: 3.125rem 2.4375rem;
                height: 3.4375rem;

                .icon{
                  width: 3.4375rem;
                  height: 3.4375rem;
                  margin-right: 1.25rem;
                }
                .info{
                  display: inline-block;
                  vertical-align: top;

                  .label{
                    color: #9A9A9A;
                    font-size: 1rem;
                    line-height: 1.1875rem;
                    margin-bottom: .8125rem;
                  }
                  .value{
                    color: #292929;
                    font-size: 1.125rem;
                    line-height: 1.5rem;
                    font-weight: bold;
                  }
                }
              }
            }
            .consult{
              width: 32.6875rem;
              border-radius: 0 0 3.125rem 0;
              border: .0625rem solid rgba(0,0,0,0.1);

              .cover{
                width: 100%;
                height: 13.875rem;
              }
              .title{
                color: #373737;
                font-size: 2rem;
                line-height: 2.375rem;
                font-weight: 700;
                margin: 1.3125rem 3.9375rem .9375rem;
              }
              .des{
                color: #9A9A9A;
                font-size: 1rem;
                font-weight: 1.1875rem;
                font-weight: 400;
                margin: 0 3.9375rem;
              }
              .login-form{
                margin: 2.5rem 3.9375rem;

                .el-form-item{
                  margin-bottom: 1.25rem;
                  height: 2.5rem;
                }
                /deep/ .el-form-item__content{
                  line-height: 2.5rem;
                  font-size: .875rem;
                }
                /deep/ .el-form-item__error{
                  font-size: .75rem;
                  padding-top:.25rem;
                }
                .input{
                  width: 25rem;
                  height: 2.5rem;
                  font-size: 1.125rem;
                }
                /deep/ .el-input__inner{
                  height: 2.5rem;
                }
                .btn{
                  margin-top: 1.25rem;
                  width: 25rem;
                  height: 3.125rem;
                  border-radius: .9375rem 0 .9375rem 0;
                  text-align: center;
                  font-size: 1.25rem;
                  line-height: 1.875rem;
                  letter-spacing: .0625rem;
                  padding: 0 .625rem;
                  font-weight: bold;
                }
              }
            }
          }
        }
      }
      .in{
        .text{
          animation: show 1s ease-out;
        }
        .left{
          animation: transIn 1s ease-out;
        }
        .right{
          animation: transInRight 1s ease-out;
        }
      }
      .out{
        .text{
          animation: hidden 1s ease-out;
        }
        .left{
          animation: transOut 1s ease-out;
        }
        .right{
          animation: transOutRight 1s ease-out;
        }
      }
      @keyframes show {
        from {
          opacity: 0;
        }
        to {
          opacity: 1;
        }
      }
      @keyframes hidden {
        from {
          opacity: 1;
        }
        to {
          opacity: 0;
        }
      }
      @keyframes transIn {
        from {
          transform: translate(-25rem, 0);
        }
        to {
          transform: translate(0, 0);
        }
      }
      @keyframes transOut {
        from {
          transform: translate(0, 0);
        }
        to {
          transform: translate(-25rem, 0);
        }
      }
      @keyframes transInRight {
        from {
          transform: translate(125rem, 0);
        }
        to {
          transform: translate(0, 0);
        }
      }
      @keyframes transOutRight {
        from {
          transform: translate(0, 0);
        }
        to {
          transform: translate(125rem, 0);
        }
      }
    }

  }
}
</style>
<style scoped>
.container /deep/ .el-input__inner{
  border: none;
  border-bottom: .0625rem solid #DADADA;
}
</style>